module.exports = __webpack_public_path__ + "img/angle-up-solid.e5c212b6.svg";